<template>
  <div class="full-page">
    <div class="category-container">
      <div class="category-content">
        <div class="category-title">
          <div>
            <p class="category-eyebrow">COMIC LIBRARY</p>
            <h2 class="category-heading">漫画书库</h2>
          </div>
          <div class="category-summary">
            <strong>{{ total || comicList.length }}</strong>
            <span>部作品可浏览</span>
          </div>
        </div>

        <div class="library-layout">
          <aside class="filter-section">
            <div class="filter-head">
              <span>筛选器</span>
              <button @click="fetchComics">刷新</button>
            </div>

            <div class="filter-row">
              <div class="filter-label">题材</div>
              <div class="filter-options">
                <span class="filter-option" :class="{ active: filters.material === 'all' }" @click="applyFilter('material', 'all')">全部</span>
                <span class="filter-option" :class="{ active: filters.material === 'love' }" @click="applyFilter('material', 'love')">恋爱</span>
                <span class="filter-option" :class="{ active: filters.material === 'ancient' }" @click="applyFilter('material', 'ancient')">古风</span>
                <span class="filter-option" :class="{ active: filters.material === 'fantasy' }" @click="applyFilter('material', 'fantasy')">奇幻</span>
                <span class="filter-option" :class="{ active: filters.material === 'mystery' }" @click="applyFilter('material', 'mystery')">悬疑</span>
                <span class="filter-option" :class="{ active: filters.material === 'urban' }" @click="applyFilter('material', 'urban')">都市</span>
                <span class="filter-option" :class="{ active: filters.material === 'funny' }" @click="applyFilter('material', 'funny')">搞笑</span>
              </div>
            </div>

            <div class="filter-row">
              <div class="filter-label">属性</div>
              <div class="filter-options">
                <span class="filter-option" :class="{ active: filters.paid === 'all' }" @click="applyFilter('paid', 'all')">全部</span>
                <span class="filter-option" :class="{ active: filters.paid === 'free' }" @click="applyFilter('paid', 'free')">免费</span>
                <span class="filter-option" :class="{ active: filters.paid === 'paid' }" @click="applyFilter('paid', 'paid')">付费</span>
                <span class="filter-option" :class="{ active: filters.paid === 'vip' }" @click="applyFilter('paid', 'vip')">VIP</span>
              </div>
            </div>

            <div class="filter-row">
              <div class="filter-label">进度</div>
              <div class="filter-options">
                <span class="filter-option" :class="{ active: filters.status === 'all' }" @click="applyFilter('status', 'all')">全部</span>
                <span class="filter-option" :class="{ active: filters.status === 'ongoing' }" @click="applyFilter('status', 'ongoing')">连载中</span>
                <span class="filter-option" :class="{ active: filters.status === 'finished' }" @click="applyFilter('status', 'finished')">已完结</span>
              </div>
            </div>

            <div class="filter-row">
              <div class="filter-label">排序</div>
              <div class="filter-options">
                <span class="filter-option" :class="{ active: filters.sort === 'recommend' }" @click="applyFilter('sort', 'recommend')">推荐</span>
                <span class="filter-option" :class="{ active: filters.sort === 'hot' }" @click="applyFilter('sort', 'hot')">最热</span>
                <span class="filter-option" :class="{ active: filters.sort === 'new' }" @click="applyFilter('sort', 'new')">新上架</span>
              </div>
            </div>

            <div class="filter-tip">
              根据偏好快速筛选漫画，点击作品卡片进入详情阅读。
            </div>
          </aside>

          <main class="library-main">
            <div class="featured-strip" v-if="comicList.length">
              <div class="featured-copy">
                <p>精选推荐</p>
                <h3>{{ comicList[0].title }}</h3>
                <span>{{ comicList[0].description || comicList[0].author || '从这里开始探索今日书库。' }}</span>
              </div>
              <img :src="getImageUrl(comicList[0].cover)" :alt="comicList[0].title" @click="goToComicDetail(comicList[0].id)">
            </div>

            <div class="comics-grid">
              <div v-for="comic in comicList" :key="comic.id" class="comic-item" @click="goToComicDetail(comic.id)">
                <div class="comic-cover">
                  <img :src="getImageUrl(comic.cover)" :alt="comic.title">
                </div>
                <div class="comic-btn" :class="{ 'paid': comic.is_paid === 1 }">
                  {{ comic.is_paid === 1 ? '含VIP章节' : '免费阅读' }}
                </div>
                <h3 class="comic-title">{{ comic.title }}</h3>
                <p class="comic-author">{{ comic.author }}</p>
              </div>
            </div>

            <div class="loading-state" v-if="loading">
              加载中...
            </div>

            <div class="no-data" v-if="!loading && comicList.length === 0">
              暂无数据
            </div>
          </main>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api/index'
import request from '../api/request'
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'

export default {
  name: 'CategoryPage',
  setup() {
    const router = useRouter()
    const baseUrl = ref(request.baseUrl)
    const comicList = ref([])
    const loading = ref(false)
    const total = ref(0)
    const currentPage = ref(1)
    const pageSize = ref(18)
    const filters = ref({
      material: 'all',
      paid: 'all',
      status: 'all',
      sort: 'recommend'
    })

    const fetchComics = async () => {
      loading.value = true
      comicList.value = []
      
      try {
        const params = {
          page: currentPage.value,
          limit: pageSize.value,
          _t: Date.now()
        }
        
        if (filters.value.material !== 'all') params.material = filters.value.material
        if (filters.value.paid !== 'all') params.paid = filters.value.paid
        if (filters.value.status !== 'all') params.status = filters.value.status
        if (filters.value.sort !== 'recommend') params.sort = filters.value.sort
        
        console.log('请求参数:', params)
        
        const result = await api.getComicList(params)
        
        if (result && result.data) {
          if (result.data.list && result.data.list.length > 0) {
            // 青少年模式的内容过滤已由服务端完成
            comicList.value = shuffleArray(result.data.list)
          } else {
            comicList.value = []
          }
          total.value = comicList.value.length
          console.log('获取到的漫画列表:', comicList.value)
        }
      } catch (error) {
        console.error('获取漫画列表异常:', error)
      } finally {
        loading.value = false
      }
    }

    const shuffleArray = (array) => {
      const newArray = [...array];
      for (let i = newArray.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const temp = newArray[i];
        newArray[i] = newArray[j];
        newArray[j] = temp;
      }
      return newArray;
    }

    const applyFilter = (type, value) => {
      console.log(`应用筛选: ${type} = ${value}`)
      filters.value[type] = value
      currentPage.value = 1
      fetchComics()
    }

    const goToComicDetail = (id) => {
      router.push(`/comic/${id}`)
    }

    const getImageUrl = (url) => {
      if (!url) return ''
      if (/^https?:\/\//i.test(url)) return url
      if (url.startsWith('//')) return window.location.protocol + url
      return baseUrl.value + (url.startsWith('/') ? url : `/${url}`)
    }
    
    // 页面加载时自动获取数据
    onMounted(() => {
      console.log('分类页面加载，自动获取数据')
      fetchComics()
    })

    return {
      baseUrl,
      comicList,
      loading,
      total,
      currentPage,
      pageSize,
      filters,
      fetchComics,
      shuffleArray,
      applyFilter,
      goToComicDetail,
      getImageUrl
    }
  }
}
</script>

<style scoped>
.full-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  color: #eef3ff;
}

.category-container {
  flex: 1;
  width: 100%;
  background: transparent;
  padding: 34px 0 64px;
}

.category-content {
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 20px;
}

.category-title {
  margin-bottom: 26px;
  padding: 32px;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 24px;
}

.category-eyebrow {
  margin: 0 0 10px;
  color: #ffcc66;
  font-size: 13px;
  font-weight: 900;
}

.category-summary {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.category-summary strong {
  color: #23d3ee;
  font-size: 42px;
  line-height: 1;
}

.category-summary span {
  color: #9faaca;
}

.category-heading {
  font-size: 44px;
  color: #f8fbff;
  position: relative;
  padding-left: 0;
  margin: 0;
}

.category-heading::before {
  content: '';
  position: absolute;
  left: 0;
  top: auto;
  bottom: -12px;
  transform: none;
  width: 76px;
  height: 5px;
  border-radius: 999px;
  background: linear-gradient(135deg, #ffcc66, #23d3ee);
}

.library-layout {
  display: grid;
  grid-template-columns: 280px minmax(0, 1fr);
  gap: 22px;
  align-items: start;
}

/* 筛选区域样式 */
.filter-section {
  position: sticky;
  top: 20px;
  padding: 18px;
  background: linear-gradient(180deg, rgba(20, 24, 39, 0.96), rgba(10, 13, 24, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  box-shadow: 0 28px 70px rgba(0, 0, 0, 0.32);
}

.filter-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}

.filter-head span {
  color: #f8fbff;
  font-size: 20px;
  font-weight: 900;
}

.filter-head button {
  border: 0;
  border-radius: 8px;
  padding: 8px 11px;
  color: #07101d;
  font-weight: 900;
  background: linear-gradient(135deg, #ffcc66, #23d3ee);
}

.filter-row {
  display: block;
  padding: 15px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
}

.filter-row:last-child {
  border-bottom: none;
}

.filter-label {
  margin-bottom: 10px;
  color: #23d3ee;
  font-size: 14px;
  font-weight: 900;
}

.filter-options {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.filter-option {
  padding: 8px 10px;
  border-radius: 8px;
  font-size: 13px;
  color: #aab5d4;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.06);
  transition: all 0.2s;
}

.filter-option:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.1);
}

.filter-option.active {
  color: #07101d;
  font-weight: bold;
  background: linear-gradient(135deg, #ffcc66, #23d3ee);
}

.filter-tip {
  margin-top: 16px;
  color: #9faaca;
  font-size: 13px;
  line-height: 1.7;
}

.library-main {
  min-width: 0;
}

.featured-strip {
  min-height: 220px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 180px;
  gap: 22px;
  align-items: stretch;
  margin-bottom: 22px;
  padding: 24px;
  overflow: hidden;
  border-radius: 10px;
  background:
    radial-gradient(circle at 82% 12%, rgba(255, 204, 102, 0.18), transparent 30%),
    linear-gradient(135deg, rgba(20, 24, 39, 0.96), rgba(10, 13, 24, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 28px 70px rgba(0, 0, 0, 0.32);
}

.featured-copy p {
  margin: 0 0 10px;
  color: #ffcc66;
  font-size: 13px;
  font-weight: 900;
}

.featured-copy h3 {
  margin: 0;
  color: #f8fbff;
  font-size: clamp(34px, 4vw, 64px);
  line-height: 1;
}

.featured-copy span {
  display: block;
  max-width: 720px;
  margin-top: 16px;
  color: #9faaca;
  line-height: 1.8;
}

.featured-strip img {
  width: 180px;
  height: 232px;
  object-fit: cover;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.38);
}

/* 漫画列表样式 */
.comics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  gap: 20px;
}

@media screen and (max-width: 1200px) {
  .comics-grid {
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  }
}

@media screen and (max-width: 992px) {
  .comics-grid {
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  }
}

@media screen and (max-width: 900px) {
  .library-layout {
    grid-template-columns: 1fr;
  }

  .filter-section {
    position: static;
  }
}

@media screen and (max-width: 768px) {
  .comics-grid {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  }
}

@media screen and (max-width: 576px) {
  .comics-grid {
    grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  }
}

.comic-item {
  display: flex;
  flex-direction: column;
  cursor: pointer;
  margin-bottom: 0;
  width: 100%;
  height: 100%;
  padding: 10px;
  transition: transform 0.25s ease, border-color 0.25s ease;
}

@media screen and (max-width: 640px) {
  .category-title,
  .featured-strip {
    grid-template-columns: 1fr;
    display: grid;
  }

  .category-summary {
    align-items: flex-start;
  }

  .featured-strip img {
    width: 100%;
    height: 260px;
  }
}

.comic-item:hover {
  transform: translateY(-7px);
  border-color: rgba(255, 204, 102, 0.34) !important;
}

.comic-cover {
  width: 100%;
  height: 0;
  padding-bottom: 133%; /* 宽高比约为 3:4 */
  position: relative;
  overflow: hidden;
  border-radius: 8px;
}

.comic-cover img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.comic-item:hover .comic-cover img {
  transform: scale(1.05);
}

.comic-btn {
  margin-top: 10px;
  background: linear-gradient(135deg, #23d3ee, #ffcc66);
  color: #07101d;
  text-align: center;
  padding: 6px 0;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 900;
  transition: background-color 0.2s;
}

.comic-btn:hover {
  background-color: #5daf34;
}

.comic-btn.paid {
  background: linear-gradient(135deg, #ff7a45, #ffcc66);
}

.comic-btn.paid:hover {
  background-color: #e65a5a;
}

.comic-title {
  color: #f6f8ff;
  font-size: 15px;
  font-weight: bold;
  margin: 10px 0 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.comic-author {
  font-size: 12px;
  color: #9faaca;
  margin: 0 0 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.comic-stats {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #999;
  margin: 0;
}

.loading-state {
  text-align: center;
  padding: 20px 0;
  color: #9faaca;
}

.no-data {
  text-align: center;
  padding: 40px 0;
  color: #9faaca;
  font-size: 14px;
}
</style> 
